import {z} from "zod/v4-mini"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {borderMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/convolve-helper-hal"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            sigma: z.union([z.number(), vector2Like]),
            kernelClampThresh: z._default(z.number(), 1e-2), // ratio where to cut off the kernel to bound it; default: 1e-2
            borderMode: z._default(borderMode, "renormalize"),
        }),
    },
}
